import React from 'react';

import { I18n } from '@utils/index';

import { ICache } from './InputAmountField';
import { TYPE_MAP } from './SelectTypeField';

export const formatIntVal = (val: string) => {
  return Number(val.replace(/[^\d]/g, ''));
}

export const formatFloatVal = (val: string) => {
  return val.replace(/[^\d.]/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
}

type ValidatorParams = {
  /** 金额 */
  amount: number,
  cache: React.MutableRefObject<ICache>,
  /** 数量 */
  count: number,
  /** 币种 */
  currency: string,
  assignType: string,
  form: any,
}

type ValidateRuleOption = {
  /** 当前需要被校验的key */
  currKey: string;
  /** 联动校验的key */
  linkageKey: string;
}

const getRules = (params: ValidatorParams) => {
  const { amount: value, cache, count, currency, assignType } = params;
  const { releaseMin, releaseMax, receiveMin, receiveMax } = cache.current[currency];
  const singleAmt = value / count;
  const total = value * count;
  const amountObj = {
    [TYPE_MAP.FORTUNE]: {
      singlePayAmount: value,
      singleAirDropAmount: singleAmt
    },
    [TYPE_MAP.GENERAL]: {
      singlePayAmount: total,
      singleAirDropAmount: value
    }
  };
  const { singlePayAmount, singleAirDropAmount } = amountObj[assignType] || {}
  const rules = [
    {
      rule: Number(singlePayAmount) < Number(releaseMin),
      numDesc: '',
      amountDesc: I18n.t('Qo3w0rzC') + releaseMin + currency,
      name: 'singlePay'
    },
    {
      rule: Number(singlePayAmount) >= Number(releaseMax),
      numDesc: '',
      amountDesc: currency ? I18n.t('g4QvpHV8') + releaseMax + currency : I18n.t('74lBznoN'),
      name: 'singlePay'
    },
    {
      rule: Number(singleAirDropAmount) < Number(receiveMin),
      numDesc: '',
      amountDesc: I18n.t('YffkFOyN') + receiveMin + currency,
      name: 'singleAirdrop'
    },
    {
      rule: Number(singleAirDropAmount) >= Number(receiveMax),
      numDesc: '',
      amountDesc: I18n.t('kq4MjJOI') + receiveMax + currency,
      name: 'singleAirdrop'
    }
  ]
  return rules;
}

const getIsTriggerLinkageKey = (params) => {
  const { assignType, ruleName, currency } = params;
  if (assignType === TYPE_MAP.FORTUNE) {
    return ruleName === 'singleAirdrop'
  }
  if (assignType === TYPE_MAP.GENERAL) {
    return ruleName === 'singlePay' && currency
  }
  return true
}

export const validateRule = (params: ValidatorParams, option: ValidateRuleOption) => {
  const { form, assignType, currency } = params;
  const { currKey, linkageKey } = option;
  const rules = getRules(params);
  for (const ruleObj of rules) {
    const { rule, name } = ruleObj;
    const desc = ruleObj[`${currKey}Desc`]
    if (rule) {
      if (form.trigger !== linkageKey && getIsTriggerLinkageKey({ assignType, ruleName: name, currency })) {
        form.trigger = currKey;
        form.validateFields([linkageKey]);
      }
      return Promise.reject(new Error(desc))
    }
  }
  if (!!form.trigger && form.trigger !== linkageKey) {
    form.trigger = undefined;
    form.validateFields([linkageKey]);
  }
  return Promise.resolve()
}
